import { apiHeliosClient } from 'src/data/api/apiHeliosClient';
import {
  CreateTaskCommand,
  CreateTaskCommandInput,
  CreateTaskFromQuestionCommand,
  CreateTaskFromQuestionCommandInput,
  ListTasksCommand,
  ListTasksCommandInput,
  AuditorUpdateTaskCommand,
  AuditorUpdateTaskCommandInput,
} from '@amzn/gbsa-helios-typescript-client';

export const taskService = {
  list: (data: ListTasksCommandInput) => {
    return apiHeliosClient.send(new ListTasksCommand(data));
  },
  create: (data: CreateTaskCommandInput) => {
    return apiHeliosClient.send(new CreateTaskCommand(data));
  },
  createFromQuestion: (data: CreateTaskFromQuestionCommandInput) => {
    return apiHeliosClient.send(new CreateTaskFromQuestionCommand(data));
  },
  auditorUpdate: (data: AuditorUpdateTaskCommandInput) => {
    return apiHeliosClient.send(new AuditorUpdateTaskCommand(data));
  },
};
